<template>
  <!-- member manage -->
  <div class="muban">
    <el-row :gutter="20" class="grant-wrap">
      <div class="box-right">
        <div class="right-head">
          <div class="head-shearch">
            <span
              style="
                font-family: Source Han Sans SC;
                font-weight: 400;
                color: rgba(41, 2, 2, 0.65);
                margin-left: 10px;
              "
            >
              {{
                tempInfo && tempInfo.tplName ||
                ""
              }}</span
            >
            <span>&nbsp;&nbsp;/可以将模板授权给我管理的部门成员或取消授权</span>
          </div>
          <div class="search-form">
            <el-button size="small" @click="cancelAuthFn()"
              >取消授权</el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              @click="temAuthVisibleFn"
              >授权给成员</el-button
            >
          </div>
        </div>
        <div>
          <el-table
            :data="authUSerList"
            height="78vh"
            style="border: 1px solid #eeeeee; border-bottom: 0"
            tooltip-effect="dark"
            ref="tableListRef"
            @selection-change="tableSelectionChange"
            :header-cell-style="{
              background: '#f9f9f9',
              color: '#333333',
              fontWeight: '600',
            }"
            v-loading="authUSerListLoading"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="
                (row, index) => (row.canBeAuthorized !== 1 ? false : true)
              "
            >
            </el-table-column>
            <el-table-column
              label="名称"
              prop="userName"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.userName }}（{{ scope.row.targetId }}）
              </template>
            </el-table-column>
            <el-table-column
              label="部门"
              prop="groupNames"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="280">
              <div slot-scope="scope">
                <el-button
                  type="text"
                  @click="cancelAuthFn(scope.row, 0)"
                  :class="{'option-sty':true,'dis-sty':scope.row.canBeAuthorized !== 1}"
                  >取消授权</el-button
                >
                <!--高级版本-->
                <!--                      <template v-if="isAdVn(scope.row)">-->
                <!--                        &lt;!&ndash;1草稿，2启用，3停用，4删除&ndash;&gt;-->
                <!--                        &lt;!&ndash;草稿&ndash;&gt;-->
                <!--                        <template v-if="+scope.row.status === 1">-->
                <!--                        </template>-->
                <!--                        &lt;!&ndash;已停用&ndash;&gt;-->
                <!--                        <template v-if="+scope.row.status === 3">-->
                <!--                          <span @click="qyTpl(scope.row)" class="color-success"-->
                <!--                          >启用</span-->
                <!--                          >-->
                <!--                        </template>-->
                <!--                        &lt;!&ndash;2启用&ndash;&gt;-->
                <!--                        <template v-if="+scope.row.status === 2">-->
                <!--                          <span @click="sqRow(scope.row)" class="color-success"-->
                <!--                          >授权</span-->
                <!--                          >-->
                <!--                        </template>-->
                <!--                      </template>-->
                <!--                      <template v-else>-->
                <!--                        <span @click="sqRow(scope.row)" class="color-success"-->
                <!--                        >授权</span-->
                <!--                        >-->
                <!--                      </template>-->
              </div>
            </el-table-column>
            <no-data slot="empty" text="暂无数据" />
          </el-table>
        </div>
        <!--分页栏-->
        <el-row class="pageation" style="padding-right:10px" v-if="pageTotal > 0">
          <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="sizes, prev, pager, next, total"
              :total="pageTotal"
            />
            <el-go
              :page-size="pageSize"
              :total="pageTotal"
              @current-change="handleCurrentChange"
            ></el-go>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <el-dialog
      title="模板授权"
      :visible.sync="visibleMoveOrg"
      top="5vh"
      width="50%"
      :append-to-body="true"
    >
      <p
        style="
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #290202;
          margin-bottom: 20px;
        "
      >
        <i class="warn-img el-icon-warning"></i>
        把模板授权给选中的成员，被选中的成员则可以使用模板发起签署
      </p>
      <el-tree
        ref="referenceMoveTree"
        class="tree-style"
        :data="treeGroupCopy"
        default-expand-all
        node-key="corpGroupId"
        :props="defaultProps"
        show-checkbox
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleMoveOrg = false">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="getCheckedNodes()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 所有文件预览   -->
    <el-dialog title="" :visible.sync="temListsShow" width="50%" :append-to-body="true">
      <div class="dialog_list_box">
        <div
          :class="['list_once']"
          v-for="(item, index) in tableList"
          :key="index"
        >
          <div
            @click="activeOnceFn(index, 1)"
            :class="['list_card', { active_once: activeOnce === index }]"
          >
            <img v-if="beWord(item.tplName)" src="../../../static/images/advancedVersion/file_1.png" class="img" alt="" />
            <img v-else src="../../../static/images/advancedVersion/pdf_1.png" class="img" alt="" />
<!--            <img src="../../../static/images/web/ye.png" class="img" alt="" />-->
            <p class="table">{{ item.tplName }}</p>
            <span
              @click="viewDetailFn(item)"
              class="tplName_detail"
              v-if="item.tplVersion === 2 && activeOnce === index && +item.tplType !== 4"
            >
              查看
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <!--批量发起弹窗-->
    <batch-launch
      v-if="plDialogVisible"
      :show.sync="plDialogVisible"
      :tplId="batchTplId"
    />
    <!--  模板授权  -->
    <el-dialog title="模板授权" :visible.sync="temAuthVisible" width="50%" top="5vh" :append-to-body="true">
      <div>
        <p>
          <i class="el-icon-warning"></i>
          把模板授权给选中的成员，被选中的成员则可以使用模板发起签署
        </p>
        <div style="margin: 10px 0; text-align: right">
          <el-input
            clearable
            size="small"
            placeholder="请输入邮箱/手机号"
            v-model="authUSerSearch.targetId"
            style="width: 160px; margin-right: 10px"
          ></el-input>
          <el-input
            clearable
            size="small"
            placeholder="请输入名称"
            v-model="authUSerSearch.userName"
            style="width: 160px; margin-right: 10px"
          ></el-input>
          <el-select
            v-model="authUSerSearch.corpGroupId"
            placeholder="请选择部门"
            size="small"
            style="width: 160px; margin-right: 10px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, i) in memberGroups"
              :key="i"
              :label="item.groupName"
              :value="item.corpGroupId"
            >
            </el-option>
          </el-select>
          <el-button size="small" @click="getNotAuthUserListFn">查询</el-button>
          <el-button size="small" @click="authSearchReset">重置</el-button>
        </div>
        <el-table
          v-loading="authUSerListLoading"
          :data="notAuthUSerList"
          style="border: 1px solid #eeeeee; border-bottom: 0"
          tooltip-effect="dark"
          height="78vh"
          ref="tableListRef"
          @selection-change="notAuthTableSelectionChange"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '600',
          }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          label="邮箱/手机号"
          prop="targetId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="名称"
          prop="userName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="部门"
          prop="groupNames"
          show-overflow-tooltip
        ></el-table-column>
        <no-data slot="empty" :text="tableList.length === 0 ? '您暂无模板，点击“新增流程”可创建' : '暂无数据'" />
        </el-table>
        <!--分页栏-->
        <el-row class="pageation" v-if="authUSerSearch.pageTotal > 0">
          <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
            <el-pagination
              @size-change="notAuthSizeChange"
              @current-change="notAuthCurrentChange"
              :current-page="authUSerSearch.itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="authUSerSearch.pageSize"
              layout="sizes, prev, pager, next, total"
              :total="authUSerSearch.pageTotal"
            />
            <el-go
              :page-size="authUSerSearch.pageSize"
              :total="authUSerSearch.pageTotal"
              @current-change="notAuthCurrentChange"
            ></el-go>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain type="primary" @click="notAuthUserSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "@/components/go/Go";
import BatchLaunch from "@/components/advancedVersion/batchLaunch";
import {
  name,
  enterpriseName,
  mobile,
  email
} from "@/assets/js/lib/valid-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";

export default {
  name: "templateManage",
  components: { ElGo, BatchLaunch },
  props: {
    tabAct: {
      type: String,
    },
    defaultTemId: {
      type: Number,
    },
    tempInfo:{
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      gantConf,
      moveDeptSelect: [],
      departmentArray: [],
      defaultProps: {
        children: "childCorpGroups",
        label: "label"
      },
      treeGroupCopy: [],
      visibleMoveOrg: false,
      chooseRow: null,
      itemPage: 1,
      pageTotal: 0,
      pageSize: 10,
      tableList: [],
      // 搜索条件
      searchInput: "",
      // 批量发起
      plDialogVisible: false,
      batchTplId: null,
      temListsShow: false, //  所有模板弹窗
      activeOnce: 0,
      authUSerList: [], //列表
      authUSerListLoading: false,
      tableMultipleSelection: [],
      notAuthUSerList: [], //未授权列表
      notAuthTableMultipleSelection: [], //未授权选择项
      temAuthVisible: false, //模板授权
      memberGroups: [],
      authUSerSearch: {
        corpGroupId: '',
        targetId: '',
        userName: '',
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
      }
    };
  },
  created () {
    // this.getCmListTpl('create');
  },
  mounted () {
    this.initTreeGroup();
  },
  methods: {
    // 判断文件是否是doc类型
    beWord(fileName) {
      let filesuffix = "";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      return filesuffix === "doc" || filesuffix === "docx";
    },
    emitAuthListFn() {
      // 签章授权
      this.$emit("update:tabAct", "mianSign");
    },
    //列表多选
    tableSelectionChange (val) {
      this.tableMultipleSelection = val;
    },
    //未授权列表多选
    notAuthTableSelectionChange (val) {
      this.notAuthTableMultipleSelection = val;
    },
    //未授权用户授权
    notAuthUserSubmit () {
      if (this.notAuthTableMultipleSelection.length === 0) {
        return this.$message.error('请先选择')
      } else {
        let arr = this.notAuthTableMultipleSelection.map(i => {
          return i.corpUserId;
        });
        this.grantOrRevokeTplFn(arr.join(','), 1)
      }
    },
    corpUserIdSet (n) {
      //处理多用户id
      let corpUserIdSet = "";
      let arr = this.tableMultipleSelection;
      for (let i in arr) {
        corpUserIdSet += arr[i].corpUserId + ",";
      }
      return corpUserIdSet;
    },
    //取消授权
    cancelAuthFn (row, auth) {
      const bool = this.permsEven();
      if (!bool) return
      let canBeAuthorized = row ? row.canBeAuthorized : '';
      if (row && canBeAuthorized !== 1) return this.$message.warning('暂无当前员工所在部门管理权限，如需使用请联系管理员修改权限范围');
      let str = row ? row.corpUserId : this.corpUserIdSet();
      if (!str) return this.$message.error("请先勾选成员");
      this.$confirm("确定要取消授权吗", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          if (str) {
            this.grantOrRevokeTplFn(str, 0)
          } else {
            if (this.tableMultipleSelection.length === 0) {
              return this.$message.error('请先选择')
            } else {
              let arr = this.tableMultipleSelection.map(i => {
                return i.corpUserId;
              });
              this.grantOrRevokeTplFn(arr.join(','), 0)
            }
          }
        })
        .catch(() => { });
    },
    //用户授权
    grantOrRevokeTplFn (str, auth) {
      const tplId = this.tempInfo.tplId;
      const tplVersion = this.tempInfo.tplVersion;
      let params = {
        tplId: tplId ? tplId : '',
        tplVersion: tplVersion ? tplVersion : '',
        corpUserIdSet: str,
        auth: auth,
      }
      ApiMethods.TemplateController.grantOrRevokeTpl(params).then(result => {
        if (result.success) {
          this.$message.success('操作成功');
          this.getAuthUserListFn(1);
          this.temAuthVisible = false;
        } else {
          this.$message.error(result.description)
        }
      })
    },
    //打开授权
    temAuthVisibleFn () {
      const bool = this.permsEven()
      if (!bool) return
      this.getNotAuthUserListFn();
      this.temAuthVisible = true;
    },
    //查询未授权列表
    getNotAuthUserListFn () {
      const tplId = this.tempInfo.tplId;
      if(!tplId) return;
      let param = {
        tplId: tplId,
        tplVersion: this.tempInfo.tplVersion,
        corpGroupId: this.authUSerSearch.corpGroupId,
        auth: 0,
        itemPage: this.authUSerSearch.itemPage,
        pageSize: this.authUSerSearch.pageSize,
        userName: this.authUSerSearch.userName,
        targetId: this.authUSerSearch.targetId,
      }
      this.authUSerListLoading = true;
      ApiMethods.TemplateController.cmListTplUser(param).then(result => {
        this.notAuthUSerList = result.data;
        this.authUSerSearch.pageTotal = result.total;
        this.authUSerListLoading = false;
      })
    },
    //查询授权用户列表
    getAuthUserListFn (auth) {
      const active = this.tempInfo;
      if(!(active && active.tplId)) return;
      let param = {
        tplId: active ? active.tplId : '',
        tplVersion: active ? active.tplVersion : '',
        corpGroupId: active ? active.corpGroupId : '',
        auth: auth,
        itemPage: this.itemPage,
        pageSize: this.pageSize,
        userName: '',
        targetId: '',
      }
      this.authUSerListLoading = true;
      ApiMethods.TemplateController.cmListTplUser(param).then(result => {
        this.authUSerList = result.data;
        this.pageTotal = result.total;
        this.authUSerListLoading = false;
      })
    },
    //切换active
    activeOnceFn (num, type) {
      this.activeOnce = num;
      this.temListsShow = false;
      this.getAuthUserListFn(1);
      this.$nextTick(() => {
        // 定位到选中的元素
        const ele=document.getElementById('_item' + num)
        if (type === 1 && ele && this.activeOnce > 4) document.getElementById('_item' + num).scrollIntoView({ block: "center" })
      })
    },
    //查看所有模板
    temListsShowFn () {
      this.temListsShow = true;
    },
    //只查看
    viewDetailFn (item) {
      console.log('window.location.orange',window.location.orange);
      const path=`/advancedVersion/writeVariablesView?id=${item.tplId}&control=1`
      if(isInDingTalk){
        this.$router.push({
        path: "/advancedVersion/writeVariablesView",
        query: { id: item.tplId, control: 1 }
      });
      }else{
        window.open(window.location.origin + path)
      }
    },
    initTreeGroup () {
      let params = {};
      params.permId = 6;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code === 0) {
            this.treeGroup = this.convertFormateTree(res.data);
            this.treeGroupCopy = JSON.parse(JSON.stringify(this.treeGroup));
            this.getMemberGroups(res.data);
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    getMemberGroups (data) {
      data.forEach(i => {
        this.memberGroups.push(i);
        if ((i.childCorpGroups || []).length > 0)
          this.getMemberGroups(i.childCorpGroups);
      });
    },
    // 转换成tree需要的数据格式
    convertFormateTree (data) {
      data.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    recursionChildren (childCorpGroups) {
      childCorpGroups.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    //授权页重置
    authSearchReset () {
      this.authUSerSearch = {
        corpGroupId: '',
        targetId: '',
        userName: '',
        itemPage: 1,
        pageSize: 10,
      };
      this.getNotAuthUserListFn();
    },
    // 重置
    reset () {
      this.itemPage = 1;
      this.searchInput = "";
      this.getCmListTpl();
    },
    //获取所有模板
    getCmListTpl (type) {
      ApiMethods.TemplateController.cmListTpl({
        tplName: this.searchInput,
        itemPage: this.itemPage,
        pageSize: 9999, //this.pageSize
      }).then(result => {
        if (!result.success)
          return this.$message.error(result.description || this.$tip);
        if (result.data) {
          let arr = result.data.map(i => {
            i.groupName = i.groupList.map(j => j.groupName).join(",");
            return i;
          });
          if (type === 'create') {
            this.tableList = arr.sort(item => {
              return item.tplId === this.defaultTemId ? -1 : 1;
            })
            this.activeOnce = this.tableList.findIndex((item) => {
              return item.tplId === this.defaultTemId;
            })
          } else {
            this.tableList = arr;
          }
        }
        this.getAuthUserListFn(1);
      });
    },
    setCheckedNodes (val) {
      this.chooseRow = val;
      this.moveDeptSelect = val.groupList || [];
      this.visibleMoveOrg = true;
      this.$nextTick(() =>
        this.$refs.referenceMoveTree.setCheckedNodes(this.moveDeptSelect)
      );
    },
    delTpl (val) {
      val && (this.chooseRow = val);
      ApiMethods.TemplateController.cmdelTpl({
        tplId: this.chooseRow.tplId
      }).then(result => {
        if (!result.success)
          return this.$message.error(result.description || this.$tip);
        this.$message.success("删除成功");
        this.getCmListTpl();
      });
    },
    //iD筛选
    selectIdFn () {
      let arr = this.moveDeptSelect.map((item) => {
        return item.corpGroupId;
      })

      this.moveDeptSelect = this.moveDeptSelect.filter(item => {
        return !arr.includes(item.parentId);
      });
    },
    getCheckedNodes () {
      this.visibleMoveOrg = false;
      this.moveDeptSelect = this.$refs.referenceMoveTree.getCheckedNodes();
      console.log(this.moveDeptSelect, this.moveDeptSelect[0].parentId, '[[[[[[[[[[[[[[[[')
      if (!this.moveDeptSelect.length) {
        this.moveDeptSelect = [];
      } else if (this.moveDeptSelect[0].parentId) {
        this.selectIdFn() //筛选函数
      } else {
        this.moveDeptSelect = [this.moveDeptSelect[0]]
      }
      if (this.isAdVn(this.chooseRow)) {
        // 高级版
        ApiMethods.TemplateController.advanceAssignGroup({
          tplId: this.chooseRow.tplId,
          groupIdSet: this.moveDeptSelect.map(i => i.corpGroupId).join(",")
        }).then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
          this.$message.success("操作成功");
          this.visibleMoveOrg = false;
          this.getCmListTpl();
        });
      } else {
        ApiMethods.TemplateController.assignGroup({
          tplId: this.chooseRow.tplId,
          groupIdSet: this.moveDeptSelect.map(i => i.corpGroupId).join(",")
        }).then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
          this.$message.success("操作成功");
          this.visibleMoveOrg = false;
          this.getCmListTpl();
        });
      }
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.getAuthUserListFn(1);
    },
    handleCurrentChange (val) {
      this.itemPage = val;
      this.getAuthUserListFn(1);
    },
    //未授权的分页
    notAuthSizeChange (val) {
      this.authUSerSearch.pageSize = val;
      this.getNotAuthUserListFn();
    },
    notAuthCurrentChange (val) {
      this.authUSerSearch.itemPage = val;
      this.getNotAuthUserListFn();
    },
    // 新增高级模板
    addAdvanceTpl () {
      this.$router.push({ path: "/advancedVersion/addTpl" });
    },
    // 当前是否高级模板
    isAdVn (row) {
      return +row.tplVersion === 2;
    },
    // 编辑
    editRow (row) {
      if (this.isAdVn(row)) {
        // 高级版
        this.$router.push({
          path: "/advancedVersion/addTpl",
          query: { id: row.tplId }
        });
      } else {
        this.$router.push({
          // path: "/console/authEdit",
          path: row.editorType ? "/authEdit/variableEditor" : "/console/authEdit", //替换新编辑器地址-1903
          query: { tplId: row.tplId }
        });
      }
    },
    // 授权
    sqRow (row) {
      this.setCheckedNodes(row);
    },
    // 删除确认
    deleteRow (row) {
      this.$confirm(
        "删除之后授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "com-confirmDialog"
        }
      )
        .then(() => {
          if (this.isAdVn(row)) {
            // 高级版
            this.delAdvanceTpl(row);
          } else {
            this.delTpl(row);
          }
        })
        .catch(() => {
        });
    },
    // 。。。。。。。。。。。。。。。。。。。模板管理-高级模板 start。。。。。。。。。。。。。。。。。。
    /**
     *  设置模板状态
     *  @status 1草稿，2启用，3停用，4删除
     * */
    setTplStatus (row, status, callback) {
      ApiMethods.TemplateController.advanceVSetStatus({
        tplId: row.tplId,
        status: status
      }).then(result => {
        if (!result.success)
          return this.$message.error(result.description || this.$tip);
        callback && callback();
        // this.$message.success('删除成功');
        // this.getCmListTpl();
      });
    },
    // 删除高级模板
    delAdvanceTpl (row) {
      this.setTplStatus(row, 4, () => {
        this.$message.success("删除成功");
        this.getCmListTpl();
      });
    },
    // 启用
    qyTpl (row) {
      this.setTplStatus(row, 2, () => {
        this.$message.success("启用成功");
        this.getCmListTpl();
      });
    },
    // 停用
    stopRow (row) {
      this.$confirm(
        "停用之后授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "com-confirmDialog"
        }
      )
        .then(() => {
          this.setTplStatus(row, 3, () => {
            this.$message.success("停用成功");
            this.getCmListTpl();
          });
        })
        .catch(() => {
        });
    },
    // 批量发起
    piFaQi (row) {
      this.plDialogVisible = true;
      this.batchTplId = row.tplId;
    },
    // 。。。。。。。。。。。。。。。。。。。模板管理-高级模板 end。。。。。。。。。。。。。。。。。。
    /** 权限验证 */
    permsEven (pid = gantConf.tempAuth) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid)
        this.$message.warning(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      return bool
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    btnEven () {
      const perms = this.perms;
      const bool = perms.includes(gantConf.tempAuth);
      return bool;
    }
  },
  watch:{
    tempInfo:{
      handler(val){
        this.getAuthUserListFn(1)
      },
      immediate:true,
      deep:true
    },
    defaultTemId:{
      immdiate:true,//立即执行handler函数
      handler (newVal) {
        this.activeOnce = this.tableList.findIndex((item) => {
          return item.tplId === newVal;
        })
        this.activeOnceFn(this.activeOnce,1)
      }
    }
  }
};
</script>

<style lang="less">
@import url('../../../assets/style/cssVariable.less');
.dis-sty{
  color: #ccc;
  cursor: not-allowed;
}
.tree-style .el-tree-node.is-current > .el-tree-node__content {
  background-color: @ebq-left-selected;
}
</style>
<style scoped lang="less">
.grant-wrap {
  display: flex;
  .box-right {
    flex-grow: 1;
    background-color: #ffffff;
    // max-width:57vw;
    .right-head{
      margin-bottom: 20px;
      padding: 20px 0 10px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .head-shearch{
        color: #290202; display: flex; align-items: center
      }
    }
  }
}

.tplName_detail {
  cursor: pointer;
  color: #ec1c1c;
}

.muban {
  background-color: #f5f5f5;
}

.dot-gray {
  color: #cccccc;
}

.dot-green {
  color: #67c23a;
}

.dot-red {
  color: #f56c6c;
}

.custom-transform-rotateZ-180 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
}

.custom-transform-rotateZ-0 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(0deg);
  transform: rotateZ(0deg);
}

.warn-img {
  color: #e6a23c;
  font-size: 18px;
}

.warn-img::before {
  content: "\E7A3";
}
</style>

<style lang="less" scoped>
.search-form {
  display: flex;
  align-items: center;
  margin-right: 10px;
  border-radius: 4px;
}

.color-success {
  margin-right: 10px;
  color: #290202;
  font-weight: bold;
  cursor: pointer;
}

.color-success:hover {
  color: #ec1c1c;
}

.com-myDialog {
  .spe {
    padding-left: 48px;
    padding-right: 48px;
    position: relative;
    text-align: left;

    .el-icon-warning {
      position: absolute;
      left: 26px;
      top: 3px;
    }
  }
}

.old {
  width: 25px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  background: rgba(41, 2, 2, 0.1);
  border-radius: 24px;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(41, 2, 2, 0.65);
  margin-right: 5px;
  display: inline-block;
}
.dialog_list_box {
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 790px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .list_once {
    text-align: center;
    width: 25%;
    min-width: 175px;
    margin-bottom: 20px;
    .list_card {
      border-radius: 4px;
      width: 175px;
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      &.active_once {
        border: 2px solid #ec1c1c;
        position: relative;
        .tplName_detail {
          position: absolute;
          cursor: pointer;
          top: 10px;
          right: 10px;
        }
        .table {
          background-color: #ec1c1c;
          color: #fff;
        }
      }
      .img {
        max-width: 58px;
        display: block;
        margin: 24px auto;
      }

      .table {
        height: 32px;
        line-height: 32px;
        background: rgba(239, 239, 239, 1);
        color: rgba(41, 2, 2, 0.65);
        font-size: 14px;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/console/template/tempGrant.vue